import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MASS_POST_SALE_JOBS_SLICE_NAME } from './constants';
import {
	TMassPostSaleJobOrdersRequest,
	TMassPostSaleJobOrdersResponse,
	TMassPostSaleJobsRequest,
	TMassPostSaleJobsResponse,
	TMassPostSaleJobsStore,
} from './types';

const initialState: TMassPostSaleJobsStore = {
	jobs: null,
	jobsLoading: false,

	jobOrders: null,
	jobOrdersLoading: false,
};

const massPostSaleJobs = createSlice({
	name: MASS_POST_SALE_JOBS_SLICE_NAME,
	initialState,
	reducers: {
		getMassPostSaleJobsRequest: (state, _action: PayloadAction<TMassPostSaleJobsRequest>) => {
			state.jobsLoading = true;
		},
		getMassPostSaleJobsSuccess: (state, action: PayloadAction<TMassPostSaleJobsResponse>) => {
			state.jobs = action.payload;
			state.jobsLoading = false;
		},
		getMassPostSaleJobsFailure: (state) => {
			// Drop the previous page as well: keeping it would show rows the last request never returned.
			state.jobs = null;
			state.jobsLoading = false;
		},
		clearMassPostSaleJobs: (state) => {
			state.jobs = null;
		},

		getMassPostSaleJobOrdersRequest: (
			state,
			_action: PayloadAction<TMassPostSaleJobOrdersRequest>,
		) => {
			state.jobOrdersLoading = true;
		},
		getMassPostSaleJobOrdersSuccess: (
			state,
			action: PayloadAction<TMassPostSaleJobOrdersResponse>,
		) => {
			state.jobOrders = action.payload;
			state.jobOrdersLoading = false;
		},
		getMassPostSaleJobOrdersFailure: (state) => {
			state.jobOrders = null;
			state.jobOrdersLoading = false;
		},
		clearMassPostSaleJobOrders: (state) => {
			state.jobOrders = null;
		},

		massPostSaleJobsInitState: () => initialState,
	},
});

export const {
	getMassPostSaleJobsRequest,
	getMassPostSaleJobsSuccess,
	getMassPostSaleJobsFailure,
	clearMassPostSaleJobs,
	getMassPostSaleJobOrdersRequest,
	getMassPostSaleJobOrdersSuccess,
	getMassPostSaleJobOrdersFailure,
	clearMassPostSaleJobOrders,
	massPostSaleJobsInitState,
} = massPostSaleJobs.actions;

export default massPostSaleJobs.reducer;
